<template>
  <div class="register-container">
    <div class="register-title-box">
      <span class="register-font">Register</span>
      <span class="apply-font">신청하기</span>

      <div class="register-content-box">
        <div v-if="$i18n.locale === 'ko'" class="greyd-dot"></div>
        <div v-if="$i18n.locale === 'ko'" class="greyd-dot greyd-dot-2"></div>
        <div v-if="$i18n.locale === 'ko'" class="greyd-dot greyd-dot-3"></div>
        <div v-if="$i18n.locale === 'ko'" class="greyd-dot greyd-dot-4"></div>
        <span v-html="$t('register.title')"></span>
      </div>
    </div>

    <div class="apply-container">
      <a
        class="apply-box apply-reviewer"
        href="https://greyd.kr"
        target="_blank"
      >
        <div class="apply-content-box">
          <div class="apply-content-box-title">
            <span>{{$t('register.reviewer.title')}}</span>
            <div class="toggle-button">
              <div class="toggle-inner"></div>
            </div>
          </div>
          <span class="apply-content-box-content"
            >{{$t('register.reviewer.content')}}</span
          >
          <span class="apply-content-box-hash"
            >{{$t('register.reviewer.hashtag')}}</span
          >
        </div>
      </a>
      <a
        class="apply-box apply-seller"
        href="https://greyd.kr"
        target="_blank"
      >
        <div class="apply-content-box">
          <div class="apply-content-box-title">
            <span>{{$t('register.seller.title')}}</span>
            <div class="toggle-button">
              <div class="toggle-inner"></div>
            </div>
          </div>
          <span class="apply-content-box-content"
            >{{$t('register.seller.content')}}</span
          >
          <span class="apply-content-box-hash"
            >{{$t('register.seller.hashtag')}}</span
          >
        </div>
      </a>
    </div>

    <!-- <div class="dot-squares">
      <img src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/dot-square.png" width="24%" />
      <img
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/dot-square.png"
        class="dot-square-seq"
      />
      <img
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/dot-square.png"
        class="dot-square-seq"
      />
      <img
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/dot-square.png"
        class="dot-square-seq"
      />
    </div> -->

    <!-- <img class="dot-square" src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/dot-square.png" /> -->
  </div>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/styles/register.css"></style>
<style scoped src="@/assets/styles/register-mobile.css"></style>



// WEBPACK FOOTER //
// src/components/renewal/components/Register.vue